
import React, { PureComponent } from "react";
import { ClanTag, Highlighter, Realm } from "@wg/wows-react-uikit";

import Medal from "../Medal/Medal";

import styles from "./VersusHeader.scss";

import { thousands } from "../../../helpers/formatting";
import settings from "../../../settings";

export type ISideData = {
  tag: string;
  color: string;
  realm: string;
  score: number;
  leagueData: {
    icons: {
      default: string;
    };
    number: number;
    points: Array<number>;
    title: string;
  };
};

export type IProps = {
  left: ISideData;
  right: ISideData;
  withMedal?: boolean;
};

export type IState = {};

class VersusHeader extends PureComponent<IProps, IState> {

  renderSide(data: ISideData, isReverse: boolean) {

    return <div className={isReverse ? styles.sideWrapperReverse : styles.sideWrapper}>
                {this.props.withMedal === true ? <div className={styles.medal}>
                        <Medal size="small" league={data.leagueData.number} />
                    </div> : null}
                <div className={isReverse ? styles.tagRealmWrapperReverse : styles.tagRealmWrapper}>
                    <div className={styles.tag}>
                        <ClanTag clanTag={data.tag} clanColor={data.color ? data.color : '#fff'} />
                    </div>
                    <Realm realm={data.realm} realmMap={settings.realmsMap} />
                </div>
                <div className={styles.starScoreWrapper}>
                    <div className={styles.scoreWrapper}>
                        <Highlighter className={styles.score} value={thousands(data.score)} />
                    </div>
                    <div className={styles.star} />
                </div>
            </div>;
  }

  render() {
    return <div className={styles.container}>
                {this.renderSide(this.props.left, false)}
                <div className={styles.middleSeparator} />
                {this.renderSide(this.props.right, true)}
            </div>;
  }
}

export default VersusHeader;